import { render } from "./XLoadingIcon.vue?vue&type=template&id=dfdc1762&scoped=true&ts=true"
import script from "./XLoadingIcon.vue?vue&type=script&lang=ts"
export * from "./XLoadingIcon.vue?vue&type=script&lang=ts"

import "./XLoadingIcon.vue?vue&type=style&index=0&id=dfdc1762&lang=scss"
import "./XLoadingIcon.vue?vue&type=style&index=1&id=dfdc1762&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfdc1762"]])

export default __exports__